import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => {
    return (
        <div className={styles.page}>
            <h1 className={'invisible'}>Retirement Calculator</h1>
            <iframe src="https://www.financialcalculators.net/librocu/retirement-calculator/"
                    title="Retirement Calculator" scrolling="no" frameBorder="0"></iframe>
            <IframeResize/>
        </div>
    );
}

